import { AutoMap } from '@automapper/classes';

export class MeasureMassifEntity {
    Id?: number;
    @AutoMap()
    Code!: string;
    @AutoMap()
    SamplingTime!: string;
    @AutoMap()
    Localisation!: string;
    @AutoMap()
    SamplingID!: number;
    @AutoMap()
    ScolaMaterial!: string;
    @AutoMap()
    PrelevementEffectue!: boolean;
    @AutoMap()
    IsCancelled!: boolean;
    @AutoMap()
    Observation?: string;
    @AutoMap()
    ProcessMesureTerrainCode?: string;
    @AutoMap()
    ReferenceEtiquette?: string
    @AutoMap()
    Position!: number;
}
